import { render, staticRenderFns } from "./offlineContact.vue?vue&type=template&id=1a2a2de5&scoped=true&"
import script from "./offlineContact.vue?vue&type=script&lang=js&"
export * from "./offlineContact.vue?vue&type=script&lang=js&"
import style0 from "./offlineContact.vue?vue&type=style&index=0&id=1a2a2de5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a2de5",
  null
  
)

export default component.exports